import { Map as IMap } from '@gitbook/util-immutable';

export class Data extends IMap<string, any> {}
